import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as ajaxActions from "../../actions/ajaxCounterActions";

import VerbodenStofDetailForm from "./VerbodenStofDetailForm";
import Section from "../common/Section";
import redirector from "../../util/redirector";
import VerbodenStofDetailPageHelper from "./VerbodenStofDetailPageHelper";
import ScrollToFirstErrorComponent from "../common/ScrollToFirstErrorComponent";
import { throwException } from "../../actions/exceptionActions";

class VerbodenStofDetailPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, false);

        this.filesHelper = null;
        this.state = {
            model: {}
        };

        this.pageHelper = new VerbodenStofDetailPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    render() {
        const { model } = this.state;

        return (
            <Section>
                <VerbodenStofDetailForm
                    model={model}
                />
            </Section>);
    }
}

VerbodenStofDetailPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadDefaultLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerbodenStofDetailPage);